import { AccountGroupDropdownData } from "../../../../Utils/AllPagesQuriesAndMutations";

export const data = [
  {
    name: "VerticalSection",
    sections: [
      {
        name: "Business_Details",
        VerticalSection: true,
        fields: [
          {
            id: Math.random() * 10,
            name: "Name",
            label: "Name",
            type: "text",
            FirstCharCap: true,
            isRequired: true,
            ValidationType: "VALID_STRING",
          },
          {
            id: Math.random() * 10,
            name: "Alternate_Name",
            label: "Alias or Alternate Name",
            type: "text",
            FirstCharCap: true,
          },
          {
            id: Math.random() * 10,
            name: "Account_Group",
            label: "Account Group ",
            masterName: "Account_Group",
            type: "InputDropForQuery",
            dropdowndata: AccountGroupDropdownData,
          },
          {
            id: Math.random() * 10,
            name: "Description",
            label: "Description",
            type: "textarea",
            FirstCharCap: true,
          },
        ],
      },
      {
        name: "Balance_Details",
        VerticalSection: true,
        fields: [
          {
            id: Math.random() * 10,
            name: "Balance_Method",
            label: "Balance_Method",
            type: "inputdrop",
            dropdowncontent: ["Balance Only", "Bill By Bill"],
          },
          {
            id: Math.random() * 10,
            name: "Sidebyside",
            Subfields: [
              {
                id: Math.random() * 10,
                name: "Opening_Balance",
                label: "Opening Balance",
                type: "number",
              },
              {
                id: Math.random() * 10,
                name: "Credit_Or_Debit",
                label: "Cr/Db",
                type: "inputdrop",
                dropdowncontent: ["Cr", "Db"],
                notSearchable: true,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Documents",
    label: "Other Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Doc_1",
        label: "Doc 1",
      },
      {
        id: Math.random() * 10,
        name: "Doc_2",
        label: " Doc 2",
      },
      {
        id: Math.random() * 10,
        name: "Doc_3",
        label: " Doc 3",
      },
      {
        id: Math.random() * 10,
        name: "Doc_4",
        label: " Doc 4",
      },
      {
        id: Math.random() * 10,
        name: "Doc_5",
        label: " Doc 5",
      },
    ],
  },
];

export const DefaultConfiguration = [
  {
    id: Math.random() * 10,
    name: "Config_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "accountgroups",
        label: "Default Account Group ",
        masterName: "Account_Group",
        type: "InputDropForQuery",
      },
    ],
  },
];